import React from 'react';
import PageMeta from '../components/PageMeta';

const sections = [
  {
    title: '1. Acceptance of Terms',
    body: [
      'By accessing or using The BTree Company website, subscription platform, reports, research publications, educational content or related digital services, you agree to these Terms of Use.',
      'If you do not agree to these terms, you should not use the platform or access BTree content.',
    ],
  },
  {
    title: '2. Nature of Services',
    body: [
      'BTree provides digital subscription-based access to proprietary intelligence reports, research publications, educational content and related digital services.',
      'All content is provided for informational and educational purposes only and should not be treated as financial, investment, legal, tax or professional advice.',
    ],
  },
  {
    title: '3. Account Responsibility',
    body: [
      'Users are responsible for maintaining the confidentiality of their account credentials and for all activity that occurs under their account.',
      'You agree to provide accurate information during registration, payment and account management processes.',
    ],
  },
  {
    title: '4. Subscriptions and Payments',
    body: [
      'Subscription access begins after successful payment and account activation.',
      'Subscription cancellations, refunds, upgrades and downgrades are governed by the applicable Refund Policy and Cancellation Policy published on the website.',
    ],
  },
  {
    title: '5. Intellectual Property',
    body: [
      'All reports, research, frameworks, page designs, text, graphics, data compilations and platform materials are owned by or licensed to The BTree Company.',
      'Users may not copy, reproduce, redistribute, publish, sell, sublicense or commercially exploit BTree content without prior written permission.',
    ],
  },
  {
    title: '6. Permitted Use',
    body: [
      'You may use the platform and content only for lawful personal, educational or internal professional purposes.',
      'You may not attempt to scrape, reverse engineer, bypass access controls, share paid content publicly, interfere with platform security or misuse the services in any way.',
    ],
  },
  {
    title: '7. Research Limitations',
    body: [
      'BTree content may include market, legal, policy, sector or educational analysis based on information available at the time of publication.',
      'Outcomes may differ from any scenarios, expectations or interpretations discussed in the content. Users should conduct their own independent review before relying on any information.',
    ],
  },
  {
    title: '8. Platform Availability',
    body: [
      'BTree may modify, suspend or discontinue parts of the platform or content library at any time for maintenance, operational, security or business reasons.',
    ],
  },
  {
    title: '9. Limitation of Liability',
    body: [
      'To the maximum extent permitted by applicable law, The BTree Company will not be liable for losses arising from use of the platform, reliance on content, market movements, legal developments, technical interruptions or third-party service failures.',
    ],
  },
  {
    title: '10. Changes to These Terms',
    body: [
      'BTree reserves the right to update these Terms of Use at any time. Updated versions will be published on the website.',
    ],
  },
  {
    title: '11. Contact',
    body: [
      'Questions about these Terms of Use may be sent to contact@thebtree.com.',
    ],
  },
];

const TermsOfUse = () => {
  return (
    <>
      <PageMeta
        title="Terms of Use | The B Tree"
        description="Read the terms governing access to B Tree research, subscriptions, educational content, and platform usage."
        canonical="https://www.thebtree.com/terms"
        image="https://www.thebtree.com/logo.png"
        type="website"
      />
      <main className="min-h-screen bg-[#F7F5F2]" data-testid="terms-page">
      <section className="bg-gradient-to-b from-[#FDFCFB] to-[#F7F5F2] border-b border-[#C8A84B]/20">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-18">
          <p className="text-[11px] font-mono tracking-[0.3em] uppercase text-[#C8A84B] font-semibold mb-3">
            BTree Policies
          </p>
          <h1 className="text-4xl md:text-6xl font-[Cormorant_Garamond] font-medium text-[#0D1B2A] leading-[1.05] mb-4">
            Terms of Use
          </h1>
          <p className="text-sm md:text-base text-slate-600">
            Effective Date: June 15, 2026
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-12 md:py-16">
        <article className="bg-white border border-slate-200 rounded-2xl p-6 md:p-10 shadow-sm">
          <div className="space-y-10">
            {sections.map((section) => (
              <section key={section.title}>
                <h2 className="text-2xl md:text-3xl font-[Cormorant_Garamond] font-medium text-[#0D1B2A] mb-3">
                  {section.title}
                </h2>
                {section.body.map((paragraph) => (
                  <p key={paragraph} className="text-slate-700 leading-7 mb-4">
                    {paragraph.includes('contact@thebtree.com') ? (
                      <>
                        Questions about these Terms of Use may be sent to{' '}
                        <a
                          href="mailto:contact@thebtree.com"
                          className="font-medium text-[#9B7A21] hover:text-[#0D1B2A] underline underline-offset-4"
                        >
                          contact@thebtree.com
                        </a>
                        .
                      </>
                    ) : (
                      paragraph
                    )}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </article>
      </section>
    </main>
    </>
  );
};

export default TermsOfUse;
